import _ from 'lodash'
import {pdf, renderToFile} from '@react-pdf/renderer';
import {CustomerDisclosurePDF} from "../pages/DealPage/DisclosurePDFs/Customer/Lease/CustomerDisclosurePDF";
import React from "react";
import IncentiveHelper from "./IncentiveHelper";

class QuoteHelper {
    constructor(deal, quote) {
        this.deal = deal
        this.quote = quote || this.deal.formatted_quote
    }

    get = (path, base) => _.get(base || this.quote, path)

    quoteKey = () => this.get(['Quote'])

    fees = () => this.quote.fees

    findFee = (feeId) => this.fees().find(fee => fee['TitleId'] === feeId)

    findFeeAmountOrZero = (feeId) => {
        const fee = this.findFee(feeId)
        return fee ? fee['Amount'] : 0
    }

    feesWithAmount = () => this.fees().filter((fee) => {
        return fee.amount !== 0
    })

    totalFeeAmount = () => {
        return this.fees().reduce(function(accumulator, fee) {
            return accumulator + Number(fee.amount);
        }, 0)
    }

    selectedDeskingOptions = () => this.get(['SelectedDeskingOptions'])

    term = () => _.find(this.selectedDeskingOptions(), (o) => o.Parameter === 'Term')?.Values

    lender = () => this.get(['OfferDetails', 'Lender', 'Name'])

    payment = () => this.get(['Payment'], this.quoteKey())

    advancePayment = () => this.get(['AdvancePayment'], this.quoteKey())

    purchaseOption = () => this.get(['PurchaseOption'], this.quoteKey())

    mileage = () => this.get(['QuoteParameters', 'Mileage'])

    moneyFactor = () => this.get(['QuoteParameters', 'MoneyFactor'])

    msrp = () => this.get(['QuoteParameters', 'MSRP'])

    residual = () => this.get(['OfferDetails', 'ResidualPercentage'])

    offerDetailsId = () => this.get(['OfferDetails', 'ID'])

    amountDueAtSigning = () => this.get(['Quote', 'AmountDueAtSigning'])

    amountDueOnDelivery = () => this.get(['Quote', 'AmountDueOnDelivery'])

    regularPayment = () => this.get(['Quote', 'RegularPayment'])

    transactionId = () => this.get(['TransactionId'])

    incentives = () => this.get(['OfferDetails', 'Incentives'])

    taxes = () => {
        return this.get(['Taxes'])
    }

    mrm = () => this.get(['OfferDetails', 'MRM']) || 0

    purchaseOption = () => this.get(['Quote', 'PurchaseOption'])

    apr = () => _.round(this.get(['Quote', 'APR']), 2)

    buildFee = (name, titleId) => {
        let cashdownFee = this.fees().find(f => f.TitleId === titleId)

        if (!cashdownFee) {
            cashdownFee = {
                Name: name,
                Type: 'Capped',
                Amount: 0,
                TaxRate: 0
            }
        }
        return cashdownFee
    }

    rebates = () => {
        return this.deal ? this.deal.formatted_quote.rebates : this.quote.rebates
    }
}

export default QuoteHelper